// src/admin/pages/MeetingMinutes.jsx
import React from 'react';
import DocumentsPage from './DocumentsPage';

export default function MeetingMinutes() {
    return (
        <DocumentsPage
            category="meeting_minutes"
            title="Meeting Minutes"
            description="Upload board or committee meeting minutes."
        />
    );
}
